export default {
  data() {
    return {
      xDown: null,
      yDown: null,
      dataItems: {
        left: 0,
        right: 0,
        value: 0,
        index: 0,
      },
      carouselElement: null,
    };
  },
  mounted() {
    this.carouselElement = this.$refs?.carousel;

    if (!this.carouselElement) {
      this.throwMissingRefError();
    }

    this.carouselElement.addEventListener(
      'touchstart',
      this.handleTouchStart,
      false
    );
    this.carouselElement.addEventListener(
      'touchmove',
      this.handleTouchMove,
      false
    );
    window.addEventListener('resize', this.onResize);
  },
  beforeUnmount() {
    if (!this.carouselElement) {
      this.throwMissingRefError();
    }

    this.carouselElement.removeEventListener(
      'touchstart',
      this.handleTouchStart
    );
    this.carouselElement.removeEventListener('touchmove', this.handleTouchMove);
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    onResize() {
      if (this.dataItems.left !== 0) {
        this.dataItems = {
          left: '0px',
          value: 0,
          index: 0,
          transition: '0.6s',
        };
      }
    },
    handleTouchStart(event) {
      const firstTouch = event.touches[0];
      this.xDown = firstTouch.clientX;
      this.yDown = firstTouch.clientY;
    },
    handleTouchMove(event) {
      if (!this.xDown || !this.yDown) {
        return;
      }

      const xDiff = this.xDown - event.touches[0].clientX;
      const yDiff = this.yDown - event.touches[0].clientY;

      if (Math.abs(xDiff) > Math.abs(yDiff)) {
        event.preventDefault();
        xDiff > 0
          ? this.setActiveItem('next', true)
          : this.setActiveItem('prev');
      }

      this.xDown = null;
      this.yDown = null;
    },
    setActiveItem(direction, isMobile = false) {
      throw new Error(
        `Abstract function not implemented: ${direction}, ${isMobile ? 'mobile' : ''}`
      );
    },
    throwMissingRefError() {
      throw new Error(
        'Ref "carousel" is missing! Check "mixins/carousel.js" file for the implementation'
      );
    },
  },
};
